import { render } from "./RegisterAlambrico.vue?vue&type=template&id=a73e1b20&scoped=true"
import script from "./RegisterAlambrico.vue?vue&type=script&lang=js"
export * from "./RegisterAlambrico.vue?vue&type=script&lang=js"

import "./RegisterAlambrico.vue?vue&type=style&index=0&id=a73e1b20&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a73e1b20"]])

export default __exports__